import { render } from "./yos-toast.vue?vue&type=template&id=34cf1822"
import script from "./yos-toast.vue?vue&type=script&lang=js"
export * from "./yos-toast.vue?vue&type=script&lang=js"

import "./yos-toast.vue?vue&type=style&index=0&id=34cf1822&lang=postcss"
script.render = render

export default script